import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormInput } from '../FormComponents/Input/Input';
import ComboBox, { POSITIONING_STRATEGY } from '../Fundamentals/ComboBox';
import SwitchToggle from "../SwitchToggle";

const BokaMeraForm = ({ booking, readonly, onFieldChange, onEmployeeSelected, availableResources, employees }) => {
    const { t } = useTranslation();
    const [selectedEmployee, setSelectedEmployee] = useState(null);

    useEffect(() => {
        booking.customFields.forEach(field => {
            onFieldChange(field.name, field.value);
        });
    }, []);

    const sortedEmployees = employees ? [...employees].sort((a, b) =>
        a.name.localeCompare(b.name)
    ) : [];

    const onParticipantChange = (value) => {
        setSelectedEmployee(value);
        onEmployeeSelected(value, employees);
    }

    return (
        <form className="skynet-form container">
            <div className="col m-0 p-0">
                <fieldset className="d-grid col-12 gap-16 rounded-12 p-12 shadow-10">
                    <FormInput label={t('bokameraform.availableresources')} value={availableResources} readOnly={readonly} />
                    <FormInput label={t('bokameraform.service')} value={booking.service.name} readOnly={readonly} />     
                    <FormInput label={t('bokameraform.lengthinminutes')} value={booking.service.lengthInMinutes} readOnly={readonly} />    

                    {booking.service.prices.length > 0 && <FormInput label={t('bokameraform.cost')} value={booking.service.prices[0].priceText} readOnly={readonly} />}  
                    {employees && <ComboBox value={selectedEmployee} label={t('bokameraform.chooseparticipant')} options={sortedEmployees} valueKey="id" labelKey="name" onChange={(value) => { onParticipantChange(value); }} strategy={POSITIONING_STRATEGY.MODAL} isClearable/>}

                    <FormInput label={t("bokameraform.participant")} onChange={(value) => onFieldChange('contactPerson', value)} value={booking.contactPerson} />
                    <FormInput label={t('bokameraform.email')} onChange={(value) => onFieldChange('email', value)} value={booking.email} />

                    <FormInput label={t('bokameraform.phone')} onChange={(value) => onFieldChange('phone', value)} value={booking.phone} />
                    <FormInput label={t('bokameraform.fromdate')} value={booking.fromDate} readOnly={readonly} />
                    <FormInput label={t('bokameraform.todate')} value={booking.toDate} readOnly={readonly} />

                    {booking.customFields.map(field => (
                        <FormInput key={field.id} onChange={(value) => onFieldChange(field.name, value)} label={t('bokameraform.' + field.name)} value={booking[field.name]} type={field.multipleLineText ? "textarea" : ""}/>
                    ))}

                     <p>{t('bokameraform.bokameraprofile')}</p>

                    <div className="form-group">
                        <label className="col-12 control-label">{t('bokameraform.ihaveinformedthecustomer')}</label>
                            <SwitchToggle checked={booking.informedCustomer} onChange={(value) => onFieldChange("informedCustomer", value)} value={booking.informedCustomer} />
                    </div>
                </fieldset>
            </div>
        </form>
    );
};

export default BokaMeraForm;
